<template>
	<div
		class="expression-editor-container rounded-lg"
		ref="container"
		@copy="handleCopyPaste"
		@paste="handleCopyPaste"
		@cut="handleCopyPaste"
	>
		<vue-editor
			id="expression-textarea"
			v-model="textValue"
			placeholder="Écris ta réponse ici"
			:editorToolbar="customToolbar"
			@ready="onEditorReady"
		></vue-editor>
	</div>
</template>

<script>
import { VueEditor } from 'vue2-editor';

export default {
	name: 'ExpressionEditor',
	components: {
		VueEditor,
	},
	props: {
		value: {
			type: String,
			default: '',
		},
		topicSlug: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			textValue: this.value,
			customToolbar: [
				[{ size: [] }],
				['bold', 'italic', 'underline'],
				[{ list: 'ordered' }, { list: 'bullet' }],
				[{ align: [] }],
			],
		};
	},
	watch: {
		value(newValue) {
			this.textValue = newValue;
		},
		textValue(newValue) {
			this.$emit('text-change', newValue);
		},
	},
	methods: {
		handleCopyPaste(event) {
			// Only disable copy/paste for "redaction" topic
			if (this.topicSlug === 'redaction') {
				event.preventDefault();
				event.stopPropagation();
				alert(
					"Le copier-coller est désactivé pour ce champ : prenez plaisir à écrire par vous-même. C'est l'occasion idéale de progresser et de vous perfectionner !"
				);
				return false;
			}
			// For other topics, allow copy/paste (do nothing)
		},
		onEditorReady(quill) {
			const editor = quill.root;
			if (editor) {
				editor.setAttribute('spellcheck', 'false'); // Disable spellcheck
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.expression-editor-container {
	::v-deep {
		.ql-editor {
			line-height: 23px;
			font-size: 16px;
			min-height: 200px;
		}

		.ql-toolbar {
			border-top: none;
			border-left: none;
			border-right: none;
		}

		.ql-container {
			border: none;
		}

		/* Dropdown label shown (current selection) */
		.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='small']::before {
			content: 'Petit';
		}

		.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='normal']::before {
			content: 'Normal';
		}

		.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='large']::before {
			content: 'Grand';
		}

		.ql-snow .ql-picker.ql-size .ql-picker-item[data-value='huge']::before {
			content: 'Très grand';
		}

		.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='small']::before {
			content: 'Petit';
		}

		.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='normal']::before {
			content: 'Normal';
		}

		.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='large']::before {
			content: 'Grand';
		}

		.ql-snow .ql-picker.ql-size .ql-picker-label[data-value='huge']::before {
			content: 'Très grand';
		}
	}
}
</style>
